import colors from '../../../../styling/colors';
import styled from '@emotion/styled';

export const DEFAULT_GUTTER_WIDTH = '1rem';
export const DESKTOP_GUTTER_WIDTH = '4rem';
export const HEADER_LINE_HEIGHT = '1.5rem';

export const platformGutterWidth = isMobile =>
  isMobile ? DEFAULT_GUTTER_WIDTH : DESKTOP_GUTTER_WIDTH;

export const ModalHeader = styled.div`
  padding: 1rem 0;
  text-align: center;
  line-height: ${HEADER_LINE_HEIGHT};
  font-weight: 500;
  border-bottom: 1px solid ${colors('alto')};
  z-index: 1;
`;

// BaseModalContainer should be extended for any content that will be put into a modal
export const BaseModalContainer = styled.div`
  position: relative;
  width: 100%;
  z-index: 1;
`;

export const VerticalFlexContainer = styled(BaseModalContainer)`
  display: flex;
  flex-direction: column;
  height: auto;
`;

export const AccountContainer = styled(BaseModalContainer)`
  padding: 3.5rem ${({ isMobile }) => platformGutterWidth(isMobile)} 3rem;
`;

export const PaddedModalBody = styled(BaseModalContainer)`
  padding: 0 ${({ isMobile }) => platformGutterWidth(isMobile)};
  height: 100%;
`;

export const ScrollablePaddedModalBody = styled(BaseModalContainer)`
  padding: 1rem ${({ isMobile }) => platformGutterWidth(isMobile)};
  overflow-y: auto;
`;
